import { render, staticRenderFns } from "./nouvelle.vue?vue&type=template&id=565820ff"
import script from "./nouvelle.vue?vue&type=script&lang=ts"
export * from "./nouvelle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports